import { safeParseNullDefault } from 'shouldve-been-js';

class Vessel {

    private _vesselId: number;
    private _vesselName: string;
    private _imoNumber: string | null;
    private _status: string;

    public constructor(vesselId: number, vesselName: string, imoNumber: string | null, status: string) {

        this._vesselId = vesselId;
        this._vesselName = vesselName;
        this._imoNumber = imoNumber;
        this._status = status;
    }

    public get vesselId(): number {
        return this._vesselId;
    }

    public set vesselId(value: number) {
        this._vesselId = value;
    }

    public get vesselName(): string {
        return this._vesselName;
    }

    public set vesselName(value: string) {
        this._vesselName = value;
    }

    public get imoNumber(): string | null {
        return this._imoNumber;
    }

    public set imoNumber(value: string | null) {
        this._imoNumber = value;
    }

    public get status(): string {
        return this._status;
    }

    public set status(value: string) {
        this._status = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): Vessel | null {

        const vesselId: number | null = safeParseNullDefault<number>(json?.vesselId, 0);
        const vesselName: string | null = safeParseNullDefault<string>(json?.vesselName, '');
        const imoNumber: string | null = safeParseNullDefault<string>(json?.imoNumber, '');
        const status: string | null = safeParseNullDefault<string>(json?.status, '');

        if (vesselId === null || vesselName === null || status === null) {
            return null;
        }

        return new Vessel(vesselId, vesselName, imoNumber, status);
    }
}

export default Vessel;